export type Project = { slug: string; title: string; kind: string; year: number };
export async function getPublicProjects(): Promise<Project[]> {
  return fetch('/api/projects').then((response) => response.json()).then((data) => data.projects);
}
